import React, { useState, useCallback, useEffect } from "react";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import ImageResize from "quill-image-resize-module-react";

import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../../Action";
import Styles from './EditorStyles.module.css';
import AllModals from '../../../Component/Modals/allModals'
// import AllModals from "../Modals/allModals";

Quill.register("modules/imageResize", ImageResize);

function TextEditor({value, onChangeFunc, onChangeFileFunc}) {
  // const [iscallApi, setIsCallApi] = useState(false);
  const dispatch = useDispatch();
  const {advanceFilterModalToggle } = bindActionCreators(Actions,dispatch )


  const updateText = (event) => {
    onChangeFunc(event)
  };
  const modules = {
    toolbar: [
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image"],
    ],
    clipboard: {
      matchVisual: false,
    },
    imageResize: {
      parchment: Quill.import("parchment"),
      modules: ["Resize", "DisplaySize"],
    },
  };
  const formats = [
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "link",
    "image",
  ];
//   const getBase64=(file, cb)=>{
//     let reader = new FileReader();
//     reader.readAsDataURL(file);
//     reader.onload = function () {
//         cb(reader.result)
//     };
//     reader.onerror = function (error) {
//         console.log('Error: ', error);
//     };
// }

const getBase64 = (file, cb) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = function () {
      cb(reader.result);
  };
  reader.onerror = function (error) {
      console.error('Error: ', error);
  };
};



  const attachmentsData = (file) =>{
    getBase64(file,(result)=>{
        var size =
          file.size / (1024 * 1024) > 1
            ? file.size / (1024 * 1024) + " mB"
            : file.size / 1024 + " kB";
        let data = {
          caption: "",
          name: file.name,
          size: size,
          type: file.type,
          src: result,
          show: 1,
          isThumbNail: false,
        };
        onChangeFileFunc(data);
      })
  }
  return (
    <>
      <div>
        {/* <input type="file" id="actual-btn"
         onChange={(e)=>attachmentsData(e.target.files[0])} style={{display: "none"}}   name="files" required="" maxsize="500"  aria-invalid="true"></input> */}
       
        <input
        type="file"
        id="actual-btn"
        onChange={(e) => {
          const file = e.target.files[0];
          if (file) {
            attachmentsData(file);
          }
        }}
        style={{ display: "none" }}
        name="files"
        required=""
        maxsize="500"
        aria-invalid="true"
      />
        <label for="actual-btn">
        <i   className="fa fa-paperclip"
                style={{
                  position: "absolute",
                  marginLeft: "315px",
                  marginTop: "20px",
                  color: "#434343",
                  fontSize: "16px",
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
        ></i>
        </label>
        <ReactQuill
          theme="snow"
          value={value}
          modules={modules}
          formats={formats}
          onChange={(e) => updateText(e)}
        />
      </div>
      <AllModals/>
    </>
  );
}

export default TextEditor;
